"use strict";

exports.__esModule = true;
exports.features = exports.default = exports.baseUrl = void 0;
exports.polyfillIntl = polyfillIntl;
var _i18n = require("../i18n");
var _shouldPolyfill = require("@formatjs/intl-pluralrules/should-polyfill");
var _shouldPolyfill2 = require("@formatjs/intl-getcanonicallocales/should-polyfill");
function polyfillIntl(locale) {
  if ((0, _shouldPolyfill2.shouldPolyfill)()) {
    require("@formatjs/intl-getcanonicallocales/polyfill");
  }
  if ((0, _shouldPolyfill.shouldPolyfill)()) {
    require("@formatjs/intl-pluralrules/polyfill");
  }
  if (Intl.PluralRules.polyfilled) {
    var lang = locale.slice(0, 2);
    require("@formatjs/intl-pluralrules/locale-data/" + lang);
  }
}
var localeFeatures = Object.values(_i18n.localeData).reduce(function (acc, brandLocale) {
  acc.add("Intl.~locale." + brandLocale.locale);
  return acc;
}, new Set());
var features = exports.features = ["default", "es2015", "es2016", "es2017", "fetch"].concat(localeFeatures.values()).join(",");
var baseUrl = exports.baseUrl = "https://cdn.polyfill.io/v3/polyfill.min.js";
var url = baseUrl + "?features=" + features;
var _default = exports.default = url;